import { createSelector } from 'reselect';
import { Map } from 'immutable';
import {
    PROMO_STORE_KEY,
    DISCOUNT_PROMO_REWARD,
    ACCESSORY_PROMO_REWARDS,
    PROMO_REWARDS_STATE,
    REWARDS_REQUEST_STATE
} from './promoModule';

export const getPromoState = state => state.get(PROMO_STORE_KEY, Map());

export const getPromoRewards = createSelector(
    getPromoState,
    promoRewards => (promoRewards ? promoRewards.get('rewards') : null)
);

export const getIsRewardsRequestActive = createSelector(
    getPromoRewards,
    rewards => (rewards ? rewards.get(PROMO_REWARDS_STATE) === REWARDS_REQUEST_STATE.ACTIVE : false)
);


export const getDiscountRewardAmount = createSelector(
    getPromoRewards,
    rewards => (rewards ? 0 - rewards.get(DISCOUNT_PROMO_REWARD, 0) : 0)
);

export const getAccessoriesPromoData = createSelector(
    getPromoRewards,
    rewards => (rewards ? rewards.get(ACCESSORY_PROMO_REWARDS, Map()) : Map())
);
